import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import { sendPasswordRecovery } from "@/lib/supabaseAuth";

const RecuperarContrasena = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setMessage("");
    setError("");

    try {
      await sendPasswordRecovery(email);
      setMessage("Te enviamos un correo para cambiar tu contraseña.");
    } catch (authError) {
      setError(authError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header />
      <main className="min-h-screen bg-slate-50 px-4 py-24">
        <div className="mx-auto max-w-md rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-2xl font-black text-slate-950">
            Recuperar contraseña
          </h1>
          <p className="mt-2 text-sm leading-6 text-slate-600">
            Escribe tu correo y te enviaremos un enlace seguro para crear una nueva contraseña.
          </p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-3">
            <input
              required
              type="email"
              placeholder="Correo electronico"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="w-full rounded-lg border border-slate-200 p-3 outline-none focus:border-[#0056D2]"
            />

            {error && <p className="rounded-lg bg-red-50 p-3 text-sm font-semibold text-red-700">{error}</p>}
            {message && <p className="rounded-lg bg-emerald-50 p-3 text-sm font-semibold text-emerald-700">{message}</p>}

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full rounded-lg bg-[#F97316] p-3 font-black text-white disabled:bg-orange-300"
            >
              {isSubmitting ? "Enviando..." : "Enviar enlace"}
            </button>
          </form>

          <Link to="/iniciar-sesion" className="mt-4 block text-center text-sm font-black text-[#0056D2]">
            Volver a iniciar sesion
          </Link>
        </div>
      </main>
    </>
  );
};

export default RecuperarContrasena;
